import { FC, useCallback, useRef } from 'react';
import { ImageAlbum } from 'types';

import SectionStyled, { GalleryItem } from '../GridImage/styles';

type Props = {
  data: ImageAlbum[];
  onSelect?: (id: number, isSelected: boolean) => void;
  showChecked?: boolean;
  onClickImage?: (image: ImageAlbum) => void;
};

const GridImageGraft: FC<Props> = ({
  data,
  onSelect,
  onClickImage,
  showChecked = false,
  ...props
}) => {
  const refItemImage = useRef<HTMLDivElement>(null);
  const onCheckImage = useCallback(
    (index: number) => {
      onSelect && onSelect(data[index].image_id, !data[index].isSelected);
    },
    [data, onSelect]
  );

  return (
    <SectionStyled {...props}>
      <div className="images">
        {data.map((item, index) => (
          <GalleryItem
            className="gallery-item"
            ref={refItemImage}
            height={135}
            width={135}
            key={item.image_id}
          >
            <div className="gallery-item-header">
              <div className="round">
                {showChecked && (
                  <>
                    <input
                      type="checkbox"
                      onChange={() => onCheckImage(index)}
                      id={`checkbox-${item.image_id}`}
                      checked={item.isSelected}
                    />
                    <label htmlFor={`checkbox-${item.image_id}`} />
                  </>
                )}
              </div>
              {(item.testing_flag === 1 || item.edited_flag === 1) && (
                <span className="status">{item.edited_flag === 1 ? '加工済' : '工程内'}</span>
              )}
            </div>
            <img
              src={item.image_url}
              onClick={() => onClickImage && onClickImage(item)}
              alt="img-item"
              className="image cursor-pointer"
            />
            {item.isSelected && <div className="bg" />}
          </GalleryItem>
        ))}
      </div>
    </SectionStyled>
  );
};

export default GridImageGraft;
